(() => {
  const bindHeader=(root)=>{
    if(root.dataset.tshReady)return;
    root.dataset.tshReady='true';
    const button=root.querySelector('.tsh-menu-toggle'),menu=root.querySelector('.tsh-mobile-menu');
    const drawer=root.querySelector('.tsh-mobile-drawer');
    let previousOverflow='';
    const finishClose=()=>{
      menu.hidden=true;button.setAttribute('aria-expanded','false');
      button.setAttribute('aria-label',button.dataset.openLabel||'Open menu');
      if(root.dataset.drawerLocked){document.documentElement.style.overflow=previousOverflow;delete root.dataset.drawerLocked;}
      root.dispatchEvent(new CustomEvent('tsh:drawer-close'));
    };
    const toggle=(open)=>{
      if(open){
        menu.hidden=false;button.setAttribute('aria-expanded','true');
        button.setAttribute('aria-label',button.dataset.closeLabel||'Close menu');
        if(drawer&&!drawer.open){
          previousOverflow=document.documentElement.style.overflow;
          document.documentElement.style.overflow='hidden';root.dataset.drawerLocked='true';
          drawer.showModal();menu.scrollTop=0;
        }
      }else{
        if(drawer?.open)drawer.close();
        finishClose();
      }
    };
    root.tshCloseDrawer=()=>toggle(false);
    button?.addEventListener('click',()=>toggle(button.getAttribute('aria-expanded')!=='true'));
    root.querySelector('[data-drawer-close]')?.addEventListener('click',()=>toggle(false));
    drawer?.addEventListener('close',()=>{finishClose();button.focus({preventScroll:true});});
    menu?.addEventListener('click',e=>{if(e.target.closest('a'))toggle(false);});
    root.querySelector('.tsh-drawer-footer a')?.addEventListener('click',()=>toggle(false));
    root.addEventListener('keydown',e=>{if(e.key==='Escape'&&!menu.hidden){toggle(false);button.focus();}});
    const dialog=root.querySelector('.tsh-search-dialog');
    root.querySelector('[data-search-open]')?.addEventListener('click',event=>{
      const searchDrawer=document.getElementById('Search-Drawer');
      if(searchDrawer&&typeof searchDrawer.show==='function'){
        event.preventDefault();
        if(drawer?.open)toggle(false);
        root.querySelectorAll('[data-submenu-toggle][aria-expanded="true"]').forEach(control=>control.click());
        searchDrawer.show(event.currentTarget);
        searchDrawer.querySelector('input[type="search"]')?.focus({preventScroll:true});
      }else if(dialog){
        // Standalone design-preview compatibility. Shopify uses the native drawer above.
        event.preventDefault();toggle(false);dialog.showModal();
      }
      // Without JavaScript or the native component, the real /search link remains usable.
    });
    root.querySelector('[data-search-close]')?.addEventListener('click',()=>dialog.close());
    dialog?.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();dialog.close();}});
    dialog?.addEventListener('click',e=>{
      if(e.target!==dialog)return;
      const r=dialog.getBoundingClientRect();
      if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();
    });
    const desktop=matchMedia('(min-width:1001px)');
    const adapt=()=>{if(desktop.matches&&drawer?.open)toggle(false);};
    desktop.addEventListener('change',adapt);
    root.addEventListener('shopify:section:unload',()=>{toggle(false);desktop.removeEventListener('change',adapt);},{once:true});
  };
  const bindPillars=(root)=>{
    if(root.dataset.tshReady)return;
    root.dataset.tshReady='true';
    const tabs=[...root.querySelectorAll('[data-pillar]')],panel=root.querySelector('[role=tabpanel]');
    const mobile=matchMedia('(max-width:600px)'),list=root.querySelector('.tsh-pillars');
    const select=(tab)=>{
      if(mobile.matches)return;
      tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1;});
      panel.setAttribute('aria-labelledby',tab.id);
      const strong=document.createElement('strong');strong.textContent=tab.dataset.panelHeading+' ';
      panel.querySelector('p').replaceChildren(strong,document.createTextNode(tab.dataset.panelText||''));
    };
    tabs.forEach((tab,i)=>{
      tab.addEventListener('click',()=>select(tab));
      tab.addEventListener('keydown',e=>{
        if(mobile.matches)return;
        let n=i;
        if(e.key==='ArrowRight')n=(i+1)%tabs.length;
        else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;
        else if(e.key==='Home')n=0;
        else if(e.key==='End')n=tabs.length-1;
        else return;
        e.preventDefault();select(tabs[n]);tabs[n].focus();
      });
    });
    const adapt=()=>{
      list.setAttribute('role',mobile.matches?'group':'tablist');
      panel.hidden=mobile.matches;
      tabs.forEach(tab=>{
        if(mobile.matches){
          tab.removeAttribute('role');tab.removeAttribute('aria-selected');tab.removeAttribute('aria-controls');tab.tabIndex=0;
        }else{
          tab.setAttribute('role','tab');tab.setAttribute('aria-controls',panel.id);
        }
      });
      if(!mobile.matches)select(tabs[0]);
    };
    adapt();mobile.addEventListener('change',adapt);
    root.addEventListener('shopify:section:unload',()=>mobile.removeEventListener('change',adapt),{once:true});
    root.addEventListener('shopify:block:select',e=>{
      const tab=tabs.find(t=>t.dataset.tshBlock===e.detail.blockId);
      if(tab)select(tab);
    });
  };
  const init=()=>{
    document.querySelectorAll('[data-tsh-section="header"]').forEach(bindHeader);
    document.querySelectorAll('[data-tsh-section="philosophy"]').forEach(bindPillars);
  };
  init();
  document.addEventListener('shopify:section:load',init);
  const refreshCartCount=()=>{
    const route=window.Shopify?.routes?.root||'/';
    fetch(route+'cart.js',{credentials:'same-origin'}).then(r=>r.ok?r.json():null).then(c=>{
      if(c)document.querySelectorAll('[data-tsh-cart-count]').forEach(el=>el.textContent=c.item_count);
    }).catch(()=>{});
  };
  window.addEventListener('pageshow',refreshCartCount);
  if(typeof webvista!=='undefined'&&typeof webvista.subscribe==='function'){
    webvista.subscribe('cart-update',({cartData}={})=>{
      if(Number.isFinite(cartData?.item_count)){
        document.querySelectorAll('[data-tsh-cart-count]').forEach(el=>el.textContent=cartData.item_count);
      }else refreshCartCount();
    });
  }
})();
